import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from 'react';
import { Box, Button, PageEmptyState, ScrollToTopButton, Spinner } from 'seagull';
import { ActivityLogContainer } from '~/components/ActivityLogContainer/ActivityLogContainer';
import ActivityLogItem from '~/components/ActivityLogItem/ActivityLogItem';
import { useStoreActions } from '~/contexts';
import { useActivityLog } from '~/hooks/reactQuery/queries/useActivityLog';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { useOnMount } from '~/hooks/useOnMount';
import { useLocaleKeys } from '~/i18n';
import { useAppConfig } from '~/store/store-context';
import MinisiteTabHeader from '../MinisiteTabHeader/MinisiteTabHeader';
import ActivityErrorIcon from './icons/activity-error.svg';
function ActivityLog(props) {
    const { agreement, activityLogEntries } = props;
    const { logBI } = useStoreActions();
    const { scrollBehavior } = useAppConfig();
    const vendorName = "".concat(agreement.seller.firstName, " ").concat(agreement.seller.lastName);
    const clientName = "".concat(agreement.buyer.firstName, " ").concat(agreement.buyer.lastName);
    const containerRef = useRef(null);
    const [scrollContainer, setScrollContainer] = useState();
    useOnMount(()=>{
        logBI(10574);
        if (containerRef.current) {
            const node = containerRef.current.closest('[data-testid="minisite-page"]');
            if (node) {
                setScrollContainer(node);
            }
        }
    });
    return /*#__PURE__*/ _jsxs("div", {
        ref: containerRef,
        children: [
            /*#__PURE__*/ _jsx("div", {
                "data-testid": "activity-page-page-header",
                children: /*#__PURE__*/ _jsx(MinisiteTabHeader, {})
            }),
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        "data-testid": "activity-content",
                        children: activityLogEntries.map((logItem, idx)=>/*#__PURE__*/ _jsx(ActivityLogItem, {
                                isFirst: idx === 0,
                                isLast: idx === activityLogEntries.length - 1,
                                vendorName: vendorName,
                                clientName: clientName,
                                entry: logItem,
                                relationship: agreement
                            }, logItem.id()))
                    }),
                    /*#__PURE__*/ _jsx(ScrollToTopButton, {
                        bi: {
                            name: 'scroll_to_top_activity_log'
                        },
                        testId: "activity-scroll-to-top-btn",
                        scrollContainer: scrollContainer,
                        scrollBehavior: scrollBehavior
                    })
                ]
            })
        ]
    });
}
function LegacyActivityLog(param) {
    let { agreement } = param;
    const { t: agreementMinisiteTexts } = useLocaleKeys('pages.agreementMinisite');
    const { activityLog, isLoading, error, refresh } = useActivityLog(agreement.id, {
        surface: 'minisite',
        refreshOnHookMount: true
    });
    if (error) {
        return /*#__PURE__*/ _jsx(PageEmptyState, {
            illustration: /*#__PURE__*/ _jsx(ActivityErrorIcon, {}),
            message: agreementMinisiteTexts.activityLogError(),
            actions: /*#__PURE__*/ _jsx(Button, {
                bi: {
                    name: 'retry_activity_log_load'
                },
                onClick: ()=>refresh().catch(()=>{}),
                testId: "activity-error-refresh-btn",
                children: agreementMinisiteTexts.tryAgain()
            })
        });
    }
    if (isLoading) {
        return /*#__PURE__*/ _jsx(Spinner, {
            centeredInBox: true,
            centerBoxHeight: 300
        });
    }
    return /*#__PURE__*/ _jsx(ActivityLog, {
        agreement: agreement,
        activityLogEntries: activityLog,
        isRefreshing: isLoading,
        refresh: refresh
    });
}
function ActivityLogWithToolbar(param) {
    let { agreement } = param;
    const { logBI } = useStoreActions();
    useOnMount(()=>{
        logBI(10574);
    });
    return /*#__PURE__*/ _jsxs(Box, {
        children: [
            /*#__PURE__*/ _jsx(MinisiteTabHeader, {}),
            /*#__PURE__*/ _jsx(ActivityLogContainer, {
                relationship: agreement,
                surface: "minisite"
            })
        ]
    });
}
export default function WrappedActivityLog(param) {
    let { agreement } = param;
    const { ACTIVITY_LOG_NOTIFICATION_ENTRIES } = useFeatureFlags();
    if (ACTIVITY_LOG_NOTIFICATION_ENTRIES) {
        return /*#__PURE__*/ _jsx(ActivityLogWithToolbar, {
            agreement: agreement
        });
    }
    return /*#__PURE__*/ _jsx(LegacyActivityLog, {
        agreement: agreement
    });
}
